import './blog.css';

import HeaderBlog from './HeaderBlog';

const featuredPost = {
  label: 'Recomandat • 21 mai 2024',
  title: 'ContaLearn: noua experienta de invatare pentru contabilitate',
  author: 'De echipa ContaLearn',
};

const blogPosts = [
  {
    date: '20 aug 2024',
    title: 'Bilantul contabil explicat simplu, cu exemple practice',
    author: 'De echipa ContaLearn',
  },
  {
    date: '17 aug 2024',
    title: 'Cum intelegi mai rapid activele, pasivele si capitalurile',
    author: 'De echipa ContaLearn',
  },
  {
    date: '10 aug 2024',
    title: 'Balanta de verificare: pasi clari pentru incepatori',
    author: 'De echipa ContaLearn',
  },
  {
    date: '03 aug 2024',
    title: 'Dubla inregistrare explicata simplu, fara formule complicate',
    author: 'De echipa ContaLearn',
  },
];

const Blog = () => {
  return (
    <div className='blog-page'>

         <HeaderBlog />

      <section className='blog-featured'>
        <div className='blog-featured-content'>
       

          <p className='blog-featured-label'>{featuredPost.label}</p>
          <h1 className='blog-featured-title'>{featuredPost.title}</h1>
          <p className='blog-featured-author' id='authors'>{featuredPost.author}</p>
          <button className='blog-read-more' type='button'>Citeste articolul</button>
        </div>
      </section>

      <section className='blog-grid-section' id='posts'>
        <div className='blog-grid'>
          {blogPosts.map((post) => (
            <article className='blog-card' key={post.title}>
              <p className='blog-card-date'>{post.date}</p>
              <h2 className='blog-card-title'>{post.title}</h2>
              <p className='blog-card-author'>{post.author}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Blog;